import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import DropdownSelect, { SelectOption } from "components/DropdownSelect";
import { levelsDashboardStore } from "../LevelsDashboardStore";

/** Indicator selector driving which GWP value the hotspot ranking is built on. */
export default observer(function HotspotIndicatorSelect() {
  const { t } = useTranslation();
  const options = levelsDashboardStore.hotspotValueOptions;

  function handleChange(item: SelectOption | null) {
    if (!item?.value) return;
    levelsDashboardStore.setHotspotValueSelected(item.value);
  }

  if (!options.length) return null;

  return (
    <DropdownSelect
      labelName={t("levels.hotspotValueLabel")}
      options={options}
      onChange={handleChange}
      defaultValue={options.find(
        (option) => option.value === levelsDashboardStore.hotspotValueSelected
      )}
      containerClassName="w-72 shrink-0"
    />
  );
});
